/*
Poornima 09/23/2022 2700632669 User management delete popup changes
Ashraf 10/16/2022 2700632669 added code comments in search user management
prakash 26/10/2022 2700632669 added classes for new table UI and added icons,Buttons.
ashraf 10/27/2022  2700632669  user management ux changes
akhila 10/31/2022 2700632669 TablePagination bugFix
Dilip  11/01/2022 2700632669 added clickable functionality to user name
saikrishna 11/03/2022 2700632669 Changed paginationOptions
Lalitha 11/08/2022 2700632669 Added span element in Column link
Ashraf 11/15/2022 2700632669 fixed sorting payload issues
Ashraf 12/07/2022  2700632669 added login user name field
Ashraf 12/07/2022  2700632669 fixed userName issue
Akhila 12/08/2022 2700632669 added session storage for search items
Akhila 12/09/2022 2700632669 fixed session saerch issue
Sohel 12/12/2022 2700632669 Implemented System Notes Functionality
lalitha 12/12/2022 2700632669 changed column name is Active to Status
lalitha 12/12/2022 2700632669 changed status column data from Y, N to Active, In Active
Sohel 12/13/2022 2700632669 changed Deactivate User Icon
ashraf 12/14/2022  2700632669  added role based access to unlock user
Ashraf 12/15/2022 2700632669 fixed role based access
Dilip 12/23/2022 2700632669 Added Edit icon and styling on code
Suresh Peddavoora 12/23/2022 2700632669 Added Styles for Table Column data
Ashraf 01/02/2023 2700632669 fixed payload issues for search
Dilip 01/23/2023  2700632669 column data changes
Dilip 01/23/2023  2700632669 system notes payload changes
Suresh peddavoora 02/17/2023 2700632669 table data alignments
Prakash 03/16/2023 2700632669 Added Custom Action-Icons.
suresh peddavoora 03/16/2023 2700632669 Toolbar button Alignments
suresh peddavoora 04/03/2023 2700632669 add icon added
suresh peddavoora 04/06/2023 2700632669 pagination alignments fixes
Akhila 05/02/2023 2700632669 bug fix table colum data miss match
Ravi  05/04/2023 2700632669 changed status bydefault to Active
Ravi  05/04/2023 2700632669 Added reactivate user
Prakash 13-06-2023 2700632669 add icon.
Akhila 06/13/2023 2700632669 Added code and description
Ravi 06/26/2023 2700632669 fixed submit issue
Sohel 10/26/2023 2700632669 saerch screen UI and payload changes
Sohel 10/26/2023 2700632669 hide password field bug fixed
Sohel 11/07/2023 2700632669 userLoginName fixed issue in dialoge box
Sohel 12/07/2023 2700632669 Adding unlock user status and payload changes
*/

import {Button, Grid, TablePagination} from '@material-ui/core';
// import MaterialTable from "material-table";
import React, {createRef, useState, useEffect} from 'react';
import {tableIcons} from '../../../components/TableIcons';
import {defaultRows, tablePageRows} from '../../../constants/ReusableTablePagination';
import {httpPaginationPost} from '../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {useUpdateEffect} from 'react-use';
import {
  fetchAddUserData,
  deleteUserData,
  resetMessage,
  reactiveUserData,
  resetReactivMessage,
} from '../../../redux/reducers/UserManagement/AddUser';
import DialogBox from '../../../components/DialogBox';
import moment from 'moment';
import ChangePassword from './ChangePassword';
import DeleteTableRecordPopup from '../../../util/DeleteTableRecordPopup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import PageLoader from '../../../components/PageLoader';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {makeStyles} from '@material-ui/core';
import UserManagementSystemNotes from './SystemNotes';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../util/ActionMenuItem';
import AddIcon from '@material-ui/icons/AddOutlined';
// import LockOpenIcon from '@material-ui/icons/LockOpen';
import {MTableToolbar} from 'material-table';
import {lockedUser, resetMessage as unlockReset} from '../../../redux/reducers/UserManagement/UnlockUser';
// all existing users data in a table (2700632669)
const UserManagementTable = ({
  submit,
  searchData,
  setSubmit,
  setValue,
  selected,
  setSelected,
}) => {
  const tableRef = createRef();

  const [rows, setRows] = useState(defaultRows);
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isReactive, setIsReactive] = useState(false);
  const [user, setUser] = useState('');
  const [passwordDialog, setPasswordDialog] = useState(false);
  const [usersId, setUsersId] = useState('');
  const [userChange, setUserChange] = useState();
  const [isNote, setIsNote] = useState(false);
  const [userLoginName, setUserLoginName] = useState('');
  const [isUnlock, setIsUnlock] = useState(false)
  const {isLoading, deleteUserStatus, errorMsg, successMsg, reactiveStatus} = useSelector(
    ({addUser}) => addUser,
  );
  const {unlockingUserStatus, successMsg:unlockUserSuccessMsg, errorMsg:unlockUserErrorMsg} = useSelector(({unLockUser}) => unLockUser);

  const {roleData} = useSelector(({role}) => role);
  const useStyles = makeStyles((theme) => ({
    'link': {
      color: '#320469 !important',
      maxWidth: 165,
      textAlign: 'justify',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      borderBottom: '1px solid #000099',
      fontFamily: 'articulat-cf, sans-serif !important',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();
  const handleNotesDialog = () => {
    setIsNote(false);
  };
  // recall table api when user is deactivated or when made a search (2700632669)
  useUpdateEffect(() => {
    if (tableRef?.current) {
      tableRef.current.onQueryChange();
    }
  }, [searchData, deleteUserStatus, reactiveStatus, unlockingUserStatus]);

  // closing delete popup, resetting redux state delete message (2700632669)
  useEffect(() => {
    if (deleteUserStatus && deleteUserStatus === 200) {
      setTimeout(() => {
        handleClose();
      }, 1000);
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2000);
    }
  }, [deleteUserStatus]);
  useEffect(() => {
    if (reactiveStatus && reactiveStatus === 200) {
      setTimeout(() => {
        handleClose1();
      }, 1000);
      setTimeout(() => {
        dispatch(resetReactivMessage());
      }, 2000);
    }
  }, [reactiveStatus]);

  useEffect(() => {
    if (unlockingUserStatus && unlockingUserStatus === 200) {
      setTimeout(() => {
        handleClose();
      }, 1000);
      setTimeout(() => {
        dispatch(unlockReset());
      }, 2000);
    }
  }, [unlockingUserStatus]);

  // sets delete popup to open (2700632669)
  const handleUser = (rowData) => {
    setUser(rowData);
    setIsDelete(true);
  };
  const reactiveUser = (rowData) => {
    setUser(rowData);
    setIsReactive(true);
  };
  const unlockUser = (rowData) => {
    setUser(rowData);
    setIsUnlock(true);
  };
  const handleUnlockUser = () =>{
    dispatch(lockedUser(user?.userId))
  }
  // closes delete popup when no is clicked on delete popup (2700632669)
  const handleClose = () => {
    setIsDelete(false);
    setIsUnlock(false);
  };
  const handleClose1 = () => {
    setIsReactive(false);
  };

  // deleting a user by api call (2700632669)
  const handleSubmit = () => {
    dispatch(deleteUserData(user?.userId));
  };
  const handleSubmit1 = () => {
    dispatch(reactiveUserData(user?.userId));
  };
  // closes password dialog (2700632669)
  const handlePasswordClose = () => {
    setPasswordDialog(false);
  };
  const handleEdit = (rowData) => {
    dispatch(fetchAddUserData(rowData?.userId));
    setSelected(rowData?.userLoginName);
    setValue(1);
  };
  const handlePassword = (rowData) => {
    setPasswordDialog(true);
    setUsersId(rowData?.userId);
    setUserChange(rowData?.userLoginName);
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setUserLoginName(rowData);
  };
  const columns = [
    {
      title: 'User Login',
      field: 'userLoginName',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            handleEdit(rowData);
          }}
        >
          {rowData?.userLoginName}
        </span>
      ),
    },
    {
      title: 'First Name',
      field: 'firstName',
    },
    {
      title: 'Last Name',
      field: 'lastName',
    }, {
      title: 'Phone Number',
      field: 'phoneNumber',
    },
    // {
    //   title: "User Name",
    //   field: "userName",
    // },
    {
      title: 'Email Id',
      field: 'emailId',
    },
    {
      title: 'Roles',
      field: 'roles',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: '450px',
              width: '225px',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.roles ? rowData?.roles : ' '}
          </div>
        </>
      ),
    },
    {
      title: 'Company Code',
      field: 'companyCodeList',
      render: (rowData) => {
        if (rowData?.companyCodeList?.length === 1) {
          return rowData.companyCodeList;
        } else if (rowData?.companyCodeList?.length > 1) {
          return rowData?.companyCodeList?.reduce(
            (acc, item, index) =>
              index < rowData?.companyCodeList?.length - 1 ? acc + item + ', ' : acc + item + '',
            '',
          );
        }
      },
    },
    {
      title: 'Location',
      field: 'location',
    },
    {
      title: 'Locked',
      field: 'locked',
      render: (rowData) =>
        rowData?.isLocked === 'N' ? (
          <div>
            <span>No</span>
          </div>
        ) : (
          <div>
            <span>Yes</span>
          </div>
        ),
    },
    {
      title: 'Deactivated Date',
      field: 'deactiveDate',
      render: (rowData) =>
        rowData.deactiveDate ? moment(rowData.deactiveDate).format('MM/DD/YYYY') : '',
      minWidth: 50,
      type: 'date',
    },
    {
      title: 'Status',
      field: 'isActive',
      render: (rowData) =>
        rowData?.isActive === 'N' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>In Active</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Active</span>
          </div>
        ),
    },
  ];
  return (
    <>
      <DialogBox
        open={isNote}
        dialogClose={handleNotesDialog}
        title="User Management Notes"
        maxWidth="lg"
        hideFooter={true}
      >
        <UserManagementSystemNotes userLoginName={userLoginName} />
      </DialogBox>
      <Grid item xs={12}>
        <DeleteTableRecordPopup
          open={isDelete}
          dialogClose={handleClose}
          title="Deactivate User"
          value={`Are you sure want to deactivate the User : ${user?.userLoginName} ?`}
          handleSubmit={handleSubmit}
        />
        <DeleteTableRecordPopup
          open={isReactive}
          dialogClose={handleClose1}
          title="Reactivate User"
          value={`Are you sure want to Reactivate the User : ${user.userLoginName} ?`}
          handleSubmit={handleSubmit1}
        />
        <DeleteTableRecordPopup
          open={isUnlock}
          dialogClose={handleClose}
          title="Unlock User"
          value={`Are you sure want to unlock the User : ${user?.userLoginName} ?`}
          handleSubmit={handleUnlockUser}
        />
        <div className="custom-table global-field-table actions-dropdown-table new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `search/all/user`;
                const searchSessionUserManagement = JSON.parse(
                  sessionStorage.getItem('searchUserManagement'),
                );
                if (searchSessionUserManagement && !submit) {
                  searchData = searchSessionUserManagement;
                }
                const bodyObj = {
                  isActive: searchData?.isActive?.key
                    ? searchData?.isActive?.key === 'A' || searchData?.isActive?.key === 'locked'
                      ? ''
                      : searchData?.isActive?.key
                    : 'Y',
                  emailId: searchData?.emailId ? searchData.emailId.trim() : '',

                  firstName: searchData?.firstName ? searchData?.firstName : '',
                  lastName: searchData?.lastName ? searchData?.lastName : '',
                  phoneNumber: searchData?.phoneNumber ? searchData?.phoneNumber : '',
                  userLoginName: searchData?.userName ? searchData?.userName.trim() : '',
                  limit: query.pageSize ? query.pageSize : null,
                  companyCode:
                    searchData?.companyCode?.length > 0
                      ? searchData?.companyCode?.map((item) => item.value)
                      : [],
                  departmentDivision: searchData?.departmentDivision
                    ? searchData?.departmentDivision.trim()
                    : '',
                  location: searchData?.location ? searchData?.location.trim() : '',
                  roles: searchData?.roles ? searchData?.roles.trim() : '',
                  orderBy:
                    query?.orderBy && query?.orderBy?.field === 'roles'
                      ? 'roleName'
                      : query?.orderBy?.field === 'companyCodeList'
                        ? 'companyCode'
                        : query?.orderBy?.field
                          ? query?.orderBy?.field
                          : '',
                  orderDirection: query?.orderDirection,
                  page: submit
                    ? 1
                    : arrayLast && query?.page >= 1
                      ? query.page
                      : arrayLast
                        ? (query.page <= 1 && query.page + 1) || query.page - 1
                        : query.page + 1,
                  search: '',
                  isLocked: searchData?.isActive?.key === 'locked'?'Y':'',
                };
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObject;

                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(data.length === 1);
                      setSubmit(false);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            options={{
              search: false,
              // selection: true,
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbarButtonAlignment: 'left',
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: { 'aria-label': 'Rows per screen' },
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handlePassword={handlePassword}
                  handleUser={handleUser}
                  reactiveUser={reactiveUser}
                  unlockUser={unlockUser}
                  hiddenMenu={{
                    edit: false,
                    copy: true,
                    notes: false,
                    hiddenDelete: true,
                    execution: true,
                    run: true,
                    usage: true,
                    user: false,
                    password: false,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: !roleData?.window?.['User Management']?.UM?.edit,
                    disableCopy: false,
                    disableNotes: false,
                    disableUsage: false,
                    disableUser:
                       !roleData?.window?.['User Management']?.UM?.edit,
                    disablePassword:
                       !roleData?.window?.['User Management']?.UM?.edit,
                    disableRun: false,
                    disableDelete: false,
                    disableExecution: false,
                    disableTest: false,
                    disableUnlockUser:roleData?.window?.['User Management']?.['UM']?.edit,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div className="d-flex">
                    <div>
                      {
                        <Button
                          type="button"
                          variant="outlined"
                          className={`search-btn`}
                          disabled={!roleData?.window?.['User Management']?.UM?.add}
                          isFreeAction={true}
                          onClick={(event) => {
                            setValue(1);
                          }}
                          startIcon={<AddIcon />}
                        >
                          Add User
                        </Button>
                      }
                    </div>
                    {/* <div>
                      {roleData?.window?.['User Management']?.['UM']?.edit && (
                        <Button
                          type="button"
                          variant="outlined"
                          className={`mx-2 search-btn`}
                          isFreeAction={true}
                          onClick={(event) => {
                            setValue(2);
                          }}
                          startIcon={<LockOpenIcon />}
                        >
                          Unlock User
                        </Button>
                      )}
                    </div> */}
                  </div>
                </div>
              ),
            }}
            actions={[
              // {
              //   // Added Add/View button in table header for routing (2700799562)
              //   icon: () => (
              //     <>
              //       <Button
              //         type="button"
              //         variant="outlined"
              //         className={`search-btn`}
              //         disabled={!roleData?.window?.["User Management"]?.UM?.add}
              //       >
              //         Add User
              //       </Button>
              //     </>
              //   ),
              //   disabled: !roleData?.window?.["User Management"]?.UM?.add,
              //   isFreeAction: true,
              //   onClick: (event) => {
              //     setValue(1);
              //   },
              // },
              // roleData?.window?.["User Management"]?.["UM"]?.edit && {
              //   icon: () => (

              //     <>
              //       <Button
              //         type="button"
              //         variant="outlined"
              //         className={`search-btn`}
              //       // disabled={dataCount === 0}
              //       >
              //         Unlock User
              //       </Button>
              //     </>
              //   ),
              //   isFreeAction: true,
              //   onClick: (event) => {
              //     setValue(2);
              //   },
              // },
              // (rowData) => ({
              //   icon: () => <><PersonOutlineIcon  className="deactivate-user-icon"/>
              //   <ClearIcon className="deactivate-clear-icon"/></>,
              //   tooltip: "Deactivate User",
              //   disabled:
              //     rowData?.isActive === "N" || !roleData?.window?.["User Management"]?.UM?.delete,
              //   onClick: (event, rowData) => handleDelete(rowData),
              // }),
              // (rowData) => ({
              //   icon: () => <VpnKeyOutlinedIcon />,
              //   tooltip: "Change Password",
              //   disabled:
              //     rowData?.isActive === "N" || !roleData?.window?.["User Management"]?.UM?.edit,
              //   onClick: (event, rowData) => {
              //     setPasswordDialog(true);
              //     setUsersId(rowData?.userId);
              //     setUserChange(rowData?.userName);
              //   },
              // }),
              // {
              //   icon: () => <EditOutlinedIcon  />,
              //   tooltip: "Edit",
              //   disabled: !roleData?.window?.["User Management"]?.UM?.edit,
              //   onClick: (event, rowData) => {
              //     handleEdit(rowData)
              //   },
              // },
              // {
              //   icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
              //   tooltip: "User Management Notes",
              //   onClick: (event, rowData) => {
              //     setIsNote(true);
              //     setUserLoginName(rowData?.userName);
              //   },
              // },
              {
                icon: () => <SaveIcon />,
                tooltip: 'Save User',
                onClick: (event, rowData) => console.log(rowData, 'rowData'),
              },
            ]}
          />
        </div>
        <DialogBox
          maxWidth="xs"
          fullWidth="false"
          open={passwordDialog}
          dialogClose={handlePasswordClose}
          title="Change Password"
        >
          <ChangePassword
            userChange={userChange}
            selected={selected}
            setPasswordDialog={setPasswordDialog}
            usersId={usersId}
          ></ChangePassword>
        </DialogBox>
      </Grid>
      {isLoading && <PageLoader />}
      {(errorMsg || unlockUserErrorMsg) && (<ErrorSnackbar errorMsg={errorMsg || unlockUserErrorMsg} />)}
      {(successMsg || unlockUserSuccessMsg) && (<SuccessSnackbar successMsg={successMsg || unlockUserSuccessMsg} />)}
    </>
  );
};

export default UserManagementTable;
